import { Strategy } from 'utility-ts-strategy';
import { ISectionActionMenu } from '../../../interfaces/scheduler_interfaces';

export let SectionActionStrategy = new Strategy<ISectionActionMenu>({
  VIEW_DETAILS: {
    action: 'view_section_details',
    title: 'Section Details'
  },
  ADD_SECTION: {
    action: 'schedule_section',
    title: 'Add Section'
  },
  ADD_TO_WAITLIST: {
    action: 'add_to_waitlist',
    title: 'Add to Waitlist'
  },
  SWAP_SECTION: {
    action: 'swap_section',
    title: 'Swap Section'
  }
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/section_action_button/strategies/section_action_strategy.ts